import {tokens, zIndex} from '@commercial-helios/ui/theme'
import {Script} from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import {Scripts} from '@/utils/external-scripts'
import Button from '@helios/shared/components/button'
import type {LanguageCode} from '@helios/shared/locale/locales'
import {useGlobalStrings} from '@helios/shared/providers/global-strings'
import {useLocale} from '@helios/shared/providers/locale'
import mq from '@helios/shared/utils/media-query'

const LocalizationSurveyMap: Record<LanguageCode, string> = {
    en: 'uAyRkWj4',
    sv: 'ysBIIgNn',
    es: 'DBjsZz18',
    pt: 'T2wgr44O',
    no: 'iXJfuOJf',
    it: 'EcFI4ZdG',
    de: 'F77YAdPd',
    fr: 'KCPkh9Ec',
    fi: 'QRsvoTiG',
    nl: 'eItgTDa2',
    da: 'h9xVQhjv',
} as const

export const getTypeformSurveyId = (language: LanguageCode) =>
    LocalizationSurveyMap[language || 'en']

const LOCALIZATION_SURVEY_TITLE = 'Website language quality survey'

export const TypeformSurvey = () => {
    const globalStrings = useGlobalStrings()

    const language = useLocale().language
    const typeformSurveyId = getTypeformSurveyId(language)

    return (
        <>
            <FeedbackButton
                data-tf-slider={typeformSurveyId}
                data-tf-position="left"
                data-tf-opacity="100"
                data-tf-size="100"
                data-tf-iframe-props={LOCALIZATION_SURVEY_TITLE}
                data-tf-auto-close
                data-tf-transitive-search-params
                data-tf-medium="snippet"
            >
                {globalStrings.feedback}
            </FeedbackButton>
            <Script strategy="idle" src={Scripts.TYPEFORM_SCRIPT_SRC}></Script>
        </>
    )
}

const FeedbackButton = styled(Button)`
    position: fixed;
    bottom: 20px;
    left: 0;
    transform-origin: top left;
    transform: translateY(100%) rotate(-90deg);
    border-radius: 0 0 ${tokens.arc4} ${tokens.arc4};
    z-index: ${zIndex.feedbackButton};

    ${mq.min('sm')} {
        top: 50%;
        bottom: revert;
        transform-origin: top center;
        transform: translateX(-50%) rotate(270deg);
    }
`
